import React from "react";
import "./cursorAnimate";

function Cursor() {
  return (
    <div className="cursor">
      <div className="small_cursor"></div>
      <div className="big_cursor"></div>
    </div>
  );
}

export default Cursor;